import { render, staticRenderFns } from "./bookingToStore.vue?vue&type=template&id=6543e2ca&scoped=true&"
import script from "./bookingToStore.vue?vue&type=script&lang=js&"
export * from "./bookingToStore.vue?vue&type=script&lang=js&"
import style0 from "./bookingToStore.vue?vue&type=style&index=0&id=6543e2ca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6543e2ca",
  null
  
)

export default component.exports